import { useQuery } from '@base-app/web2'
import { PERMISSION_RESOURCES_QUERY } from '../graphql/permissionResources/queries'
import type { PermissionResource } from '../graphql/permissionResources/types'

// One stable reference while there is no data, so memos that depend on the catalog don't re-run
const NO_RESOURCES: PermissionResource[] = []

// The API's permission catalog in grid order (cache-first: it never changes within a session)
export function usePermissionResources() {
  const { data, loading, error, refetch } = useQuery(PERMISSION_RESOURCES_QUERY)
  return {
    resources: data?.permissionResources ?? NO_RESOURCES,
    loading: loading && !data,
    error,
    refetch,
  }
}
